import { render, staticRenderFns } from "./AddAction.vue?vue&type=template&id=46351456&scoped=true"
import script from "./AddAction.vue?vue&type=script&lang=js"
export * from "./AddAction.vue?vue&type=script&lang=js"
import style0 from "./AddAction.vue?vue&type=style&index=0&id=46351456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46351456",
  null
  
)

export default component.exports